import PropTypes from 'prop-types'

import { DatePicker, Dropdown, TextField } from 'basic-components'
import { DataLakeEnums } from 'dashboard-services/api/dataLake'

const intValidator = [{
  message: "Has to be an integer.",
  validator: val => val && Number.isInteger(Number(val))
}]
const floatValidator = [{
  message: "Has to be a number.",
  validator: val => val.valueOf() === "" || (val.valueOf() && val.valueOf() !== "" && val.isNumber({ max: Number.MAX_VALUE, min: Number.MIN_VALUE }))
}]
const GroupValueResolver = ({ defaultValue = undefined, disabled = false, menuPortalTarget = undefined, name = "defaultValue", onChange, required = false, type, ref }) => {
  switch(String(type).toLowerCase()) {
    case "integer":
    case DataLakeEnums.GROUP_FIELD_TYPE.NUMBER:
      return (
        <TextField
            defaultValue={defaultValue}
            disabled={disabled}
            name={name}
            onChange={onChange}
            placeholder="Value"
            ref={ref}
            required={required}
            step={1}
            type="number"
            validators={intValidator}
            variant="border"
        />
      )
    case DataLakeEnums.GROUP_FIELD_TYPE.DATE_MILLISECONDS:
      return (
        <TextField
            defaultValue={defaultValue}
            disabled={disabled}
            min={0}
            name={name}
            onChange={onChange}
            placeholder="Value"
            ref={ref}
            required={required}
            step={1}
            type="number"
            validators={intValidator}
            variant="border"
        />
      )
    case DataLakeEnums.GROUP_FIELD_TYPE.DECIMAL_NUMBER:
      return (
        <TextField
            defaultValue={defaultValue}
            disabled={disabled}
            name={name}
            onChange={onChange}
            placeholder="Value"
            ref={ref}
            required={required}
            step={.1}
            type="number"
            validators={floatValidator}
            variant="border"
        />
      )
    case DataLakeEnums.GROUP_FIELD_TYPE.DATE:
      return (
        <DatePicker
            defaultValue={defaultValue}
            disabled={disabled}
            fixed
            name={name}
            onChange={onChange}
            ref={ref}
            required={required}
            variant="border"
        />
      )
    default:
    case DataLakeEnums.GROUP_FIELD_TYPE.TEXT:
      return (
        <TextField
            defaultValue={defaultValue}
            disabled={disabled}
            name={name}
            onChange={onChange}
            placeholder="Value"
            ref={ref}
            required={required}
            variant="border"
        />
      )
    case DataLakeEnums.GROUP_FIELD_TYPE.ARRAY:
      return (
        <Dropdown
            creatable
            defaultValue={defaultValue}
            disabled={disabled}
            menuPortalTarget={menuPortalTarget}
            multi
            name={name}
            onChange={onChange}
            ref={ref}
            required={required}
            variant="border"
        />
      )
  }
}

GroupValueResolver.displayName = "GroupValueResolver"

GroupValueResolver.propTypes = {
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  menuPortalTarget: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired
}

export default GroupValueResolver
